import { CustomerProjectListComponent } from './../documents/customer-projects/customer-project-list/customer-project-list.component';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CustomerSalesPurchaseDetailsComponent } from '../documents/customer-sales-purchases/customer-sales-purchase-detail/customer-sales-purchase-details.component';
import { CustomerSalesPurchaseListComponent } from '../documents/customer-sales-purchases/customer-sales-purchase-list/customer-sales-purchase-list.component';
import { QuoteDetailComponent } from '../documents/quotes/quote-detail/quote-detail.component';
import { QuoteListComponent } from '../documents/quotes/quote-list/quote-list.component';
import { CustomerCreditNoteDetailComponent } from '../documents/customer-credit-notes/customer-credit-note-details/customer-credit-note-detail.component';
import { CustomerCreditNoteListComponent } from '../documents/customer-credit-notes/customer-credit-note-list/customer-credit-note-list.component';
import { CustomerDeliveryNoteDetailComponent } from '../documents/customer-delivery-notes/customer-delivery-note-detail/customer-delivery-note-detail.component';
import { CustomerDeliveryNoteListComponent } from '../documents/customer-delivery-notes/customer-delivery-note-list/customer-delivery-note-list.component';
import { CustomerPreparationDetailComponent } from '../documents/customer-preparations/customer-preparation-detail/customer-preparation-detail.component';
import { CustomerPreparationListComponent } from '../documents/customer-preparations/customer-preparation-list/customer-preparation-list.component';
import { CustomerInvoiceDetailComponent } from '../documents/customer-invoices/customer-invoice-detail/customer-invoice-detail.component';
import { CustomerInvoiceListComponent } from '../documents/customer-invoices/customer-invoice-list/customer-invoice-list.component';
import { CustomerReturnNoteDetailComponent } from '../documents/customer-return-notes/customer-return-note-detail/customer-return-note-detail.component';
import { CustomerReturnNoteListComponent } from '../documents/customer-return-notes/customer-return-note-list/customer-return-note-list.component';
import { CustomerReturnRequestDetailComponent } from '../documents/customer-return-requests/customer-return-request-detail/customer-return-request-detail.component';
import { CustomerReturnRequestListComponent } from '../documents/customer-return-requests/customer-return-request-list/customer-return-request-list.component';
import { DocumentListComponent } from '../documents/document-list/document-list.component';
import { CustomerOpenOrderLinesListComponent } from '../documents/customer-open-order-lines/customer-open-order-lines-list.component';
import { LogisticFeatureDefinition, SaleFeatureDefinition } from '@digiwall/goliath-documents/config';
import { CustomerProjectDetailComponent } from '../documents/customer-projects/customer-project-details/customer-project-detail.component';

const routes: Routes = [
  {
    path: 'documents',
    children: [
      {
        path: 'quotes',
        pathMatch: 'full',
        title: 'Doc::Menu:Offers',
        canMatch: [SaleFeatureDefinition],
        component: QuoteListComponent,
      },
      {
        path: 'quotes',
        title: 'Doc::Menu:Offers',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:Offers',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: QuoteDetailComponent,
          },
        ],
      },
      {
        path: 'sales-purchases',
        pathMatch: 'full',
        title: 'Doc::Menu:SalesPurchases',
        canMatch: [SaleFeatureDefinition],
        component: CustomerSalesPurchaseListComponent,
      },
      {
        path: 'sales-purchases',
        title: 'Doc::Menu:SalesPurchases',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:SalesPurchases',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerSalesPurchaseDetailsComponent,
          },
        ],
      },

      {
        path: 'delivery-notes',
        pathMatch: 'full',
        title: 'Doc::Menu:DeliveryOrder',
        canMatch: [SaleFeatureDefinition],
        component: CustomerDeliveryNoteListComponent,
      },
      {
        path: 'customer-preparations',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerPreparations',
        canMatch: [SaleFeatureDefinition, LogisticFeatureDefinition],
        component: CustomerPreparationListComponent,
      },
      {
        path: 'delivery-notes',
        title: 'Doc::Menu:DeliveryOrder',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerDeliveryNotes',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerDeliveryNoteDetailComponent,
          },
        ],
      },
      {
        path: 'customer-preparations',
        title: 'Doc::Menu:CustomerPreparations',
        canMatch: [SaleFeatureDefinition, LogisticFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerPreparations',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerPreparationDetailComponent,
          },
        ],
      },
      {
        path: 'customer-return-notes',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerReturnNotes',
        canMatch: [SaleFeatureDefinition],
        component: CustomerReturnNoteListComponent,
      },
      {
        path: 'customer-return-notes',
        title: 'Doc::Menu:CustomerReturnNotes',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerReturnNotes',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerReturnNoteDetailComponent,
          },
        ],
      },
      {
        path: 'customer-credit-notes',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerCreditNotes',
        canMatch: [SaleFeatureDefinition],
        component: CustomerCreditNoteListComponent,
      },
      {
        path: 'customer-credit-notes',
        title: 'Doc::Menu:CustomerCreditNotes',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerCreditNotes',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerCreditNoteDetailComponent,
          },
        ],
      },
      {
        path: 'customer-return-requests',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerReturnRequests',
        canMatch: [SaleFeatureDefinition],
        component: CustomerReturnRequestListComponent,
      },
      {
        path: 'customer-return-requests',
        title: 'Doc::Menu:CustomerReturnRequests',
        canMatch: [SaleFeatureDefinition],

        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerReturnRequests',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerReturnRequestDetailComponent,
          },
        ],
      },
      {
        path: 'documents',

        pathMatch: 'full',
        title: 'Doc::Menu:Documents',
        canMatch: [SaleFeatureDefinition],
        component: DocumentListComponent,
      },
      {
        path: 'documents',
        title: 'Doc::Menu:Documents',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:Document',
          } as BreadcrumbDefinition,
        },
        component: DocumentListComponent,
      },
      {
        path: 'customer-invoices',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerInvoices',
        canMatch: [SaleFeatureDefinition],
        component: CustomerInvoiceListComponent,
      },
      {
        path: 'customer-invoices',
        title: 'Doc::Menu:CustomerInvoices',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerInvoices',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerInvoiceDetailComponent,
          },
        ],
      },
      {
        path: 'customer-open-order-lines',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerOpenOrderLines',
        canMatch: [SaleFeatureDefinition],
        component: CustomerOpenOrderLinesListComponent,
      },
      {
        path: 'customer-projects',
        pathMatch: 'full',
        title: 'Doc::Menu:CustomerProjects',
        canMatch: [SaleFeatureDefinition],
        component: CustomerProjectListComponent,
      },
      {
        path: 'customer-projects',
        title: 'Doc::Menu:CustomerProjects',
        canMatch: [SaleFeatureDefinition],
        data: {
          breadcrumb: {
            label: 'Doc::Menu:CustomerProjects',
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: ':id',
            data: {
              breadcrumb: {
                alias: 'entityName',
              } as BreadcrumbDefinition,
            },
            component: CustomerProjectDetailComponent,
          },
        ],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsSaleRoutingModule {}
